/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { PaymentsActivationModalDetails } from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class PaymentActivationController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags payment-activation-controller
   * @name NotifyLegalReps
   * @request POST:/api/v1/payments/activation/notify-legal-reps
   */
  notifyLegalReps = (params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/payments/activation/notify-legal-reps`,
      method: 'POST',
      ...params,
    })

  static notifyLegalRepsPath = '/v1/payments/activation/notify-legal-reps'
  static notifyLegalRepsMethod = 'POST'
  /**
   * No description
   *
   * @tags payment-activation-controller
   * @name NotifyLegalRep
   * @request POST:/api/v1/payments/activation/legal-reps/{legalRepUserId}/notify
   */
  notifyLegalRep = (legalRepUserId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/payments/activation/legal-reps/${legalRepUserId}/notify`,
      method: 'POST',
      ...params,
    })

  static notifyLegalRepPath = '/v1/payments/activation/legal-reps/${legalRepUserId}/notify'
  static notifyLegalRepMethod = 'POST'
  /**
   * No description
   *
   * @tags payment-activation-controller
   * @name GetPaymentsActivationModalDetails
   * @request GET:/api/v1/payments/activation/modal-details
   */
  getPaymentsActivationModalDetails = (params: RequestParams = {}) =>
    this.http.request<PaymentsActivationModalDetails, any>({
      path: `/v1/payments/activation/modal-details`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getPaymentsActivationModalDetailsPath = '/v1/payments/activation/modal-details'
  static getPaymentsActivationModalDetailsMethod = 'GET'
}
